// Legacy imports - kept for backward compatibility but not used directly
// These are now handled by the modular utils files

// Re-export from new modular structure
import { formatTime, formatFechaDDMMYYYY, formatDateTime, getFormattedTimeDifference, newDateFormated, getCurrentDateTime, formatDate, formatearFecha, esHoy, getCurrentLocalISODateTime } from './utils/dateTimeUtils.js';
import { correctWeight, traducirMetal, urlExiste } from './utils/validationUtils.js';
import { getLanguage, getFullUser, deleteUser } from './utils/userUtils.js';
import { getListOptionsStoneList, getListOptionsTimeWork, getListOptionsProblemAndSolutions } from './utils/listProcessingUtils.js';
import { convertToMinutes, getArrayInfoDataUpdate, parseDurationToMinutes, extraerMinutos, getPrecioTotalPorRango, formatNumber, cleanUserName, formatPiedrasForModal, safeString } from './utils/dataProcessingUtils.js';
import { getStatusDelivery } from './utils/deliveryUtils.js';

const stone = "PIEDRAS";
const process = "PROCESOS";

// Re-export all functions for backward compatibility
export {
  // Date/Time utilities
  formatTime,
  formatFechaDDMMYYYY,
  formatDateTime,
  getFormattedTimeDifference,
  newDateFormated,
  getCurrentDateTime,
  formatDate,
  formatearFecha,
  esHoy,
  getCurrentLocalISODateTime,
  
  // Validation utilities
  correctWeight,
  traducirMetal,
  urlExiste,
  
  // User utilities
  getLanguage,
  getFullUser,
  deleteUser,
  
  // List processing utilities
  getListOptionsStoneList,
  getListOptionsTimeWork,
  getListOptionsProblemAndSolutions,
  
  // Data processing utilities
  convertToMinutes,
  getArrayInfoDataUpdate,
  parseDurationToMinutes,
  extraerMinutos,
  getPrecioTotalPorRango,
  formatNumber,
  cleanUserName,
  formatPiedrasForModal,
  safeString,
  
  // Delivery utilities
  getStatusDelivery
};
